import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HTTP_CP_EnergyPerformanceCertificate } from '@api-new/propertyservice';
import { WidgetEpcImprovementsCarouselComponent } from '@platform/dashboard/components/widget-container/components/widget-epc-improvements/components/widget-epc-improvements-carousel/widget-epc-improvements-carousel.component';
import { WidgetHeaderComponent } from '@platform/dashboard/components/widget-container/components/widget-header/widget-header.component';
import { paths } from '@platform/paths';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'cp-widget-epc-improvements',
  imports: [CommonModule, ButtonDirective, WidgetHeaderComponent, WidgetEpcImprovementsCarouselComponent, RouterLink],
  templateUrl: './widget-epc-improvements.component.html',
  styleUrls: ['../../shared/widget.scss', './widget-epc-improvements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetEpcImprovementsComponent {
  @Input({ required: true }) epc: HTTP_CP_EnergyPerformanceCertificate;
  @Input({ required: true }) propertyId: string;
  @Input({ required: true }) propertyName: string;

  protected readonly paths = paths;
}
